import { Menu } from "@headlessui/react";

export const ProductActionMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handleExportProducts,
    handleAddAttribute,
    handleUploadProductClick,
    handleAddTagsProducts
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left">
									<div>
										<Menu.Button
											onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
											className="p-2 bg-slate-300 hover:bg-slate-400 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
											title="More Actions..."
										>
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
												<path d="M13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 19.5C13.5 18.6716 12.8284 18 12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21C12.8284 21 13.5 20.3284 13.5 19.5Z" stroke="currentColor" stroke-width="1.5" />
											</svg>
										</Menu.Button>
									</div>
									{anchorShipmentEl && (
										<Menu.Items className="absolute z-20 ms-3 my-1 bg-white border border-gray-300 rounded shadow-lg p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
											<div className="px-1 py-1">
												{/* Product Related Actions Section */}
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleExportProducts();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Export Products"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="26" height="24">
																<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-4-4z" fill="none" stroke="currentColor" stroke-width="2" />
																<path d="M12 10v6m-3-3l3 3 3-3" stroke="currentColor" stroke-width="2" />
															</svg>
															<span className='mx-3'>Export Products</span>
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleAddAttribute();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Add Function Attributes"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="26" height="24">
																<path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
															</svg>
															<span className='mx-3'>Function Attributes</span>
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleUploadProductClick();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Import Products"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="26" height="24">
																<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-4-4z" fill="none" stroke="currentColor" stroke-width="2" />
																<path d="M12 14v-6m-2 2l2 2 2-2" stroke="currentColor" stroke-width="2" />
															</svg>
															<span className='mx-3'>Import Products</span>
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleAddTagsProducts();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Add Tags"
														>
															<svg width="28" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 58.415 58.415">
																<g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
																<g id="SVGRepo_iconCarrier"> <g>
																	<path stroke="currentColor" stroke-width="2" d="M50.09,32.745l6.325-6.308V12.296L45.3,1.207H31.295h0l-0.759,0.757L6,26.42l0.008,0.008L0,32.42l25.147,25.201 l8.796-8.773c1.58,5.4,6.568,9.359,12.471,9.359c7.168,0,13-5.832,13-13C59.415,39.316,55.473,34.335,50.09,32.745z M44.473,3.207 l9.942,9.919v12.48l-6.69,6.667c-0.094-0.01-0.191-0.007-0.286-0.015c-0.074-0.006-0.149-0.013-0.222-0.019 c-0.057-0.004-0.118-0.011-0.174-0.015c-0.215-0.012-0.423-0.019-0.628-0.019c-7.168,0-13,5.832-13,13 c0,0.199,0.006,0.401,0.018,0.611c0.004,0.072,0.013,0.15,0.018,0.224c0.005,0.065,0.01,0.132,0.016,0.2 c0.006,0.076,0.004,0.155,0.012,0.231l-2.328,2.321L8.837,26.432L32.122,3.207H44.473z M2.829,32.424l4.592-4.58l22.321,22.369 l-4.592,4.58L2.829,32.424z M46.415,56.207c-5.549,0-10.139-4.134-10.883-9.481l-0.003-0.02c-0.022-0.161-0.033-0.3-0.049-0.448 c-0.008-0.073-0.018-0.152-0.024-0.222c-0.021-0.275-0.042-0.549-0.042-0.829c0-6.065,4.935-11,11-11 c0.281,0,0.557,0.021,0.833,0.042c0.044,0.004,0.094,0.011,0.139,0.015c0.18,0.018,0.356,0.034,0.556,0.062l0.025,0.003 c5.331,0.759,9.447,5.341,9.447,10.877C57.415,51.273,52.48,56.207,46.415,56.207z"></path>
																	<path stroke="currentColor" stroke-width="1" d="M52.415,44.207h-5v-5c0-0.553-0.448-1-1-1s-1,0.447-1,1v5h-5c-0.552,0-1,0.447-1,1s0.448,1,1,1h5v5c0,0.553,0.448,1,1,1 s1-0.447,1-1v-5h5c0.552,0,1-0.447,1-1S52.967,44.207,52.415,44.207z"></path>
																	<path stroke="currentColor" stroke-width="1.5" d="M42.43,18.077c2.17,0,3.935-1.765,3.935-3.935s-1.765-3.936-3.935-3.936s-3.936,1.766-3.936,3.936 S40.26,18.077,42.43,18.077z M42.43,12.207c1.067,0,1.935,0.868,1.935,1.936c0,1.066-0.868,1.935-1.935,1.935 c-1.067,0-1.936-0.868-1.936-1.935C40.494,13.075,41.362,12.207,42.43,12.207z"></path>
																</g> </g>
															</svg>
															<span className='mx-3'>Tags</span>
														</button>
													)}
												</Menu.Item>
												{/* <Menu.Item>
												{({ active }) => (
													<button
														onClick={() => {
															handlePublishProducts();
															setAnchorShipmentEl(null);
														}}
														className={`${active ? 'bg-gray-200' : ''
															} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
													// title="Publish Products"
													>
														<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="28" height="24">
															<path d="M6 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6c.3 0 .6.03.9.08a5.992 5.992 0 0 1 11.2 0C18.4 6.03 18.7 6 19 6a6 6 0 0 1 6 6 6 6 0 0 1-6 6h-2z" fill="none" stroke="currentColor" stroke-width="2" />
															<path d="M14 10l4 4-4 4-4-4 4-4z" stroke="currentColor" stroke-width="2" />
															<path d="M16 16l-4 4-4-4" stroke="currentColor" stroke-width="2" />
														</svg>
														<span className='mx-3'>Publish Products</span>
													</button>
												)}
											</Menu.Item> */}
											</div>
										</Menu.Items>
									)}
								</Menu>
        </>
    )
}